import { matchCreditCardTypes } from 'utils/Orders/matchCreditCardsTypes'

import { ReactComponent as IconCash } from 'assets/icons/payment/IconCash.svg'
import { ReactComponent as IconCustomTender } from 'assets/icons/payment/IconCustomTender.svg'
import { ReactComponent as IconDirectBill } from 'assets/icons/payment/IconDirectBill.svg'
import { ReactComponent as IconHouseAccount } from 'assets/icons/payment/IconHouseAccount.svg'
import { ReactComponent as IconVirtualCurrency } from 'assets/icons/payment/IconVirtualCurrency.svg'
import { ReactComponent as IconVisa } from 'assets/icons/payment/IconVisa.svg'
import { ReactComponent as IconTicket } from 'assets/icons/payment/IconTicket.svg'
import { ReactComponent as IconAmex } from 'assets/icons/payment/IconAmex.svg'
import { ReactComponent as IconMasterCard } from 'assets/icons/payment/IconMasterCard.svg'
import { ReactComponent as IconDiscover } from 'assets/icons/payment/IconDiscover.svg'
import { ReactComponent as IconSplitPay } from 'assets/icons/payment/IconSplitPay.svg'
import { ReactComponent as IconWalletNonce } from 'assets/icons/payment/IconWalletNonce.svg'
import { ReactComponent as IconGiftCard } from 'assets/icons/payment/IconGiftCard.svg'
import { ReactComponent as IconUnknownPayment } from 'assets/icons/payment/IconUnknownPayment.svg'

export const renderPaymentIconWithLabelByPaymentTypeNumber = ({
  paymentType,
  cardName,
  lastFour,
  paymentTypeDisplayName,
}) => {
  // if payment type is negative we return -1 value in order to return
  // IconCustomTender Icon
  const paymentTypeValue = paymentType < 0 ? -1 : paymentType

  const { isVisa, isAmericanExpress, isDiscover, isMasterCard } =
    matchCreditCardTypes(cardName)

  // when payment type is equal 1 || 3 || 14 || 22 || 28 || 29 || 30 we have to check
  // card name (api substitude: creditCardDetails.freedompayIssuerName) in order to return
  // one of 4 card types
  switch (paymentTypeValue) {
    case 1:
    case 3:
    case 14:
    case 22:
    case 28:
    case 29:
    case 30: {
      switch (true) {
        case isVisa:
          return { icon: <IconVisa />, label: `*${lastFour ?? ''}` }

        case isAmericanExpress:
          return { icon: <IconAmex />, label: `*${lastFour ?? ''}` }

        case isDiscover:
          return { icon: <IconDiscover />, label: `*${lastFour ?? ''}` }

        case isMasterCard:
          return { icon: <IconMasterCard />, label: `*${lastFour ?? ''}` }

        default:
          return { icon: <IconUnknownPayment />, label: 'Unknown' }
      }
    }
    case 9:
      return { icon: <IconVirtualCurrency />, label: 'Virtual Currency' }
    case -1:
      return { icon: <IconCustomTender />, label: paymentTypeDisplayName ?? '' }
    case 19:
      return { icon: <IconCash />, label: 'Cash' }
    case 24:
      return { icon: <IconDirectBill />, label: 'Direct Bill' }
    case 27:
      return { icon: <IconHouseAccount />, label: 'House Account' }
    case 23:
    case 36: // vnapi_ticket
      return { icon: <IconTicket />, label: 'Ticket' }
    case 33:
    case 35: // vnapi_qrpay
      return { icon: <IconWalletNonce />, label: 'Wallet Nonce' }
    case 'Split Payment':
      return { icon: <IconSplitPay />, label: 'Split Pay' }
    case 34:
    case 37: // vnapi_giftcard
      return { icon: <IconGiftCard />, label: 'Gift Card' }
    default:
      return { icon: <IconUnknownPayment />, label: 'Unknown' }
  }
}
